module.exports = __webpack_public_path__ + "static/media/mission.73ed90ed.svg";